import React from 'react';
import { useLanguage } from '../context/LanguageContext';
import { motion } from 'framer-motion';
import { PageHeader } from '../components/PageHeader';
import { Reservations } from '../components/Reservations';
export function ReservationsPage() {
  const {
    t
  } = useLanguage();
  return <motion.div initial={{
    opacity: 0,
    filter: 'blur(4px)'
  }} animate={{
    opacity: 1,
    filter: 'blur(0px)'
  }} exit={{
    opacity: 0,
    filter: 'blur(4px)'
  }} transition={{
    duration: 0.6,
    ease: [0.4, 0, 0.2, 1]
  }} data-id="element-562">
      <PageHeader title={t.reservations.title} subtitle={t.reservations.subtitle} backgroundImage="https://cdn.magicpatterns.com/uploads/noRonfkFvEGEVmZXgXRQ4r/download_(4).png" data-id="element-563" />

      <Reservations data-id="element-564" />
    </motion.div>;
}